import React, { useState, useEffect } from "react";
import { Container, Grid } from '@mui/material';
import { 
  getLovValues, 
  fetchMaterialList, 
  fetchBudgetRangeList, 
  fetchAggregatorList,
  fetchStorageLocation 
} from '../resourceCommonAPIs';
import CommonLOVGrid from "./commonLOVGrid";
import { getCategoryUrnList } from "../rateCard/rateCardAPIs";

function ManagePlantationLOV() {
  const [bambooSPeciesArr, setBambooSPeciesArr] = useState([]);
  const [saplingTypeArr, setSaplingTypeArr] = useState([]);
  const [saplingSourceArr, setSaplingSourceArr] = useState([]);
  const [materialListArr, setMaterialListArr] = useState([]);
  const [budgetRangeListArr, setBudgetRangeListArr] = useState([]);
  const [aggregatorArr, setAggregatorArr] = useState([]);
  const [speciesSelectedRow, setSpeciesSelectedRow] = useState();
  const [saplingTypeSelectedRow, setSaplingTypeSelectedRow] = useState();
  const [saplingSourceSelectedRow, setSaplingSourceSelectedRow] = useState();
  const [materialListSelectedRow, setMaterialListSelectedRow] = useState();
  const [budgetListSelectedRow, setBudgetListSelectedRow] = useState();
  const [aggregatorIdSelected, setAggregatorIdSelected] = useState();
  
  const [storageLocationListArr, setStorageLocationListArr] = useState([]);
  const [storageLocListSelectedRow, setStorageLocListSelectedRow] = useState();
  
  const [stakeholderType, setStakeholderType] = useState();
  const [urnList, setUrnList] = useState();

  useEffect(() => {
    getLovValues(setBambooSPeciesArr, setSaplingTypeArr, setSaplingSourceArr);
    fetchMaterialList(setMaterialListArr);
    fetchBudgetRangeList(setBudgetRangeListArr);
    fetchAggregatorList(setAggregatorArr);
    getCategoryUrnList(stakeholderType, setUrnList);
    fetchStorageLocation(setStorageLocationListArr); 
  }, [stakeholderType]);

  return (
    <>
      <Container maxWidth="xl">
        <Grid container spacing={1}>
          <Grid item xs={12} lg={6}>
            <CommonLOVGrid arr={bambooSPeciesArr} setArr={setBambooSPeciesArr} selectedRow={speciesSelectedRow} setSelectedRow={setSpeciesSelectedRow} lovType="species" lovText="Species" applicationType="Bamboo_species" setBambooSPeciesArr={setBambooSPeciesArr} setSaplingTypeArr={setSaplingTypeArr} setSaplingSourceArr={setSaplingSourceArr}/> 
          </Grid>
          <Grid item xs={12} lg={6}>
            <CommonLOVGrid arr={saplingTypeArr} setArr={setSaplingTypeArr} selectedRow={saplingTypeSelectedRow} setSelectedRow={setSaplingTypeSelectedRow} lovType="saplingType" lovText="Sapling Type" applicationType="Type_of_sapling" setBambooSPeciesArr={setBambooSPeciesArr} setSaplingTypeArr={setSaplingTypeArr} setSaplingSourceArr={setSaplingSourceArr}/> 
          </Grid>
          <Grid item xs={12} lg={6}>
            <CommonLOVGrid arr={saplingSourceArr} setArr={setSaplingSourceArr} selectedRow={saplingSourceSelectedRow} setSelectedRow={setSaplingSourceSelectedRow} lovType="saplingSource" lovText="Sapling Source" applicationType="Source_of_sapling" setBambooSPeciesArr={setBambooSPeciesArr} setSaplingTypeArr={setSaplingTypeArr} setSaplingSourceArr={setSaplingSourceArr}/> 
          </Grid>
          <Grid item xs={12} lg={6}>
            <CommonLOVGrid arr={materialListArr} setArr={setMaterialListArr} selectedRow={materialListSelectedRow} setSelectedRow={setMaterialListSelectedRow} lovType="materialList" lovText="Material List" applicationType="Material_list" setMaterialListArr={setMaterialListArr}/> 
          </Grid>
          <Grid item xs={12} lg={6}>
            <CommonLOVGrid arr={budgetRangeListArr} setArr={setBudgetRangeListArr} selectedRow={budgetListSelectedRow} setSelectedRow={setBudgetListSelectedRow} lovType="budgetRange" lovText="Budget Range" setBudgetRangeListArr={setBudgetRangeListArr}/> 
          </Grid>
          <Grid item xs={12} lg={6}>
            <CommonLOVGrid arr={aggregatorArr} setArr={setAggregatorArr} selectedRow={aggregatorIdSelected} setSelectedRow={setAggregatorIdSelected} lovType="aggregatorId" lovText="Aggregator ID" setAggregatorArr={setAggregatorArr}/> 
          </Grid>
          
          <Grid item xs={12} lg={12}>
            <CommonLOVGrid 
              arr={storageLocationListArr} 
              setArr={setStorageLocationListArr} 
              selectedRow={storageLocListSelectedRow} 
              setSelectedRow={setStorageLocListSelectedRow} 
              lovType="storageLocation" 
              lovText="Storage Location" 
            /> 
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
export default ManagePlantationLOV;

